import BaseService from "@/shared/base.service";
import { useAlertStore } from "@/stores/alert.store";

export class PlanService {
  static async GetAllPlans(
    page: number,
    size: number,
    id?: string
  ): Promise<any | null> {
    try {
      const params = {
        page,
        size,
        id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<any>(
        `plans`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllPlans:", error);
      useAlertStore().show("error", "Erro ao buscar planos!");
      return null;
    }
  }
}
